import { format } from "date-fns";

export function formatDateForDisplay(dateString) {
  if (!dateString) return "-";

  return format(dateString, "dd MMM, yyyy");
}